// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ZZYD","productName":"Table_productName__3HQCA"};